/**
 * @generated SignedSource<<69377a37a59f77883e82add91896877d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleHeader_store$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePermissions_store">;
  readonly " $fragmentType": "TeamScheduleHeader_store";
};
export type TeamScheduleHeader_store$key = {
  readonly " $data"?: TeamScheduleHeader_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHeader_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleHeader_store",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissions_store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "3dc14d089920565846facceb0c97b3d2";

export default node;
